import Button from "../../../../ui/button/Button"//"react-bootstrap";
import langs from "../../../../../common/services/languageService";
const { labels } = langs;

function PointOfSalePopup({ userPosition, pointOfSale }) {
  const handleNavigateButton = () => {
    let url = `https://www.google.com/maps/dir/?api=1`;
    if (userPosition) url += `&origin=${userPosition[0]},${userPosition[1]}`;
    if (pointOfSale) url += `&destination=${pointOfSale.position[0]},${pointOfSale.position[1]}`;
    window.open(url, "_blank");
  };

  return (
    <div className="flex flex-column">
      <div className="fw-bold fs-5 mb-2">{pointOfSale.type}</div>
      <div className="fw-bold mb-1 ">{pointOfSale.street}</div>
      <div className="fw-bold mb-2">
        {pointOfSale.postalCode} {pointOfSale.city}
      </div>
      <Button className="text-capitalize fs-6" variant="primary" onClick={handleNavigateButton}>
        {labels.NavigateGoogleMaps()}
      </Button>
    </div>
  );
}

export default PointOfSalePopup;
